import React from 'react';
import PropTypes from 'prop-types';
import ChartistGraph from 'react-chartist';
import {
  withStyles,
  Typography,
  Icon,
  Grid,
  CircularProgress,
  IconButton,
  Button,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';

import styles from './styles';

const Chartist = require('chartist');

const colouredLinesChart = {
  options: {
    axisY: { showGrid: true },
    axisX: {
      showGrid: false,
      offset: 100,
    },
    showPoint: true,
    height: '300px',
  },
  // for animation
  animation: {
    draw(data) {
      if (data.type === 'line' || data.type === 'area') {
        data.element.animate({
          d: {
            begin: 600,
            dur: 700,
            from: data.path
              .clone()
              .scale(1, 0)
              .translate(0, data.chartRect.height())
              .stringify(),
            to: data.path.clone().stringify(),
            easing: Chartist.Svg.Easing.easeOutQuint,
          },
        });
      } else if (data.type === 'point') {
        data.element.animate({
          opacity: {
            begin: (data.index + 1) * 80,
            dur: 500,
            from: 0,
            to: 1,
            easing: 'ease',
          },
        });
      }
    },
  },
};

const getData = (analytics, selectedView, page, size) => {
  if (analytics.analyticBreakdowns && analytics.analyticBreakdowns[selectedView]) {
    return {
      labels: analytics.analyticBreakdowns[selectedView].fields
        .slice(page * size, (page * size) + size),
      series: analytics.analyticBreakdowns[selectedView].values
        .map((val) => val.slice(page * size, (page * size) + size)),
    };
  }
  return {
    labels: [],
    series: [],
  };
};

export class EventCreationTrendingCardComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      size: 8,
      selectedView: 'createdCompletedDaily', // default
    };
  }

  clickPageBack = () => {
    this.setState((prevState) => ({ page: prevState.page - 1 }));
  }

  clickPageForward = () => {
    this.setState((prevState) => ({ page: prevState.page + 1 }));
  }

  changeView = (selectedView) => {
    this.setState({
      page: 0,
      selectedView,
    });
  }

  render() {
    const {
      classes,
      analytics,
      loading,
    } = this.props;
    const {
      page,
      size,
      selectedView,
    } = this.state;

    const length = (analytics.analyticBreakdowns
      && analytics.analyticBreakdowns[selectedView])

      ? analytics.analyticBreakdowns[selectedView].fields.length
      : 0;

    return (
      <Card>
        <CardHeader title={<Typography variant="h4" color="textPrimary">Created vs Completed Events</Typography>} />
        <CardContent style={{ textAlign: 'center' }}>
          { loading && <CircularProgress /> }
          { (!loading && length > 0)
            ? (
              <ChartistGraph
                data={getData(analytics, selectedView, page, size)}
                options={colouredLinesChart.options}
                type="Line"
                key={Math.random()} // needed to force redraw
                listener={{
                  draw: (ctx) => {
                    if (ctx.type === 'label' && ctx.x !== 10) {
                    // adjust label position for rotation
                      const dX = ctx.width / 2 + (125 - ctx.width);
                      ctx.element.attr({ x: ctx.element.attr('x') - dX });
                    }
                  },
                }}
              />
            )
            : <Typography>No data</Typography>}
          {
            !loading
              && length > 0
              && (
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6}>
                    <span style={{ float: 'left' }}>
                      <Button
                        variant={selectedView === 'createdCompletedDaily'
                          ? 'contained'
                          : 'text'}
                        size="small"
                        className={classes.viewButton}
                        color="primary"
                        onClick={() => this.changeView('createdCompletedDaily')}
                      >
                        day
                      </Button>
                      <Button
                        variant={selectedView === 'createdCompletedWeekly'
                          ? 'contained'
                          : 'text'}
                        size="small"
                        className={classes.viewButton}
                        color="primary"
                        onClick={() => this.changeView('createdCompletedWeekly')}
                      >
                        week
                      </Button>
                      <Button
                        variant={selectedView === 'createdCompletedMonthly'
                          ? 'contained'
                          : 'text'}
                        size="small"
                        className={classes.viewButton}
                        color="primary"
                        onClick={() => this.changeView('createdCompletedMonthly')}
                      >
                        month
                      </Button>
                    </span>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <div style={{ textAlign: 'right' }}>
                      <span className={classes.paginationText}>
                        {`showing ${page * size}-${((page * size) + size) > length
                          ? length
                          : ((page * size) + size)} of ${length}`}
                      </span>
                      <IconButton
                        className={classes.paginationIcon}
                        onClick={this.clickPageBack}
                        disabled={page <= 0}
                      >
                        <Icon>
                          chevron_left
                        </Icon>
                      </IconButton>
                      <IconButton
                        className={classes.paginationIcon}
                        onClick={this.clickPageForward}
                        disabled={((page * size) + size) >= length}
                      >
                        <Icon>
                          chevron_right
                        </Icon>
                      </IconButton>
                    </div>
                  </Grid>
                </Grid>
              )
          }
          <Grid container direction="row" alignItems="center">
            <h6 className={classes.greyColor}>Legend</h6>
          </Grid>
          <Grid container direction="row" alignItems="center">
            <Grid item>
              <Icon fontSize="small" className={classes.footerCreate}>fiber_manual_record</Icon>
            </Grid>
            <Grid item>
              Created
            </Grid>
            <Grid item>
              <Icon fontSize="small" className={classes.footerComplete}>fiber_manual_record</Icon>
            </Grid>
            <Grid item>
              Completed
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

EventCreationTrendingCardComponent.propTypes = {
  classes: PropTypes.object,
  analytics: PropTypes.object,
  loading: PropTypes.bool,
};

EventCreationTrendingCardComponent.defaultProps = {
  classes: {},
  analytics: {},
  loading: false,
};

export default (withStyles(styles, { withTheme: true })(EventCreationTrendingCardComponent));
